import FormButton from "../../../../Components/Buttons/FormButton";
import { MobileFooterProps } from "../Model/Mobile.type";

const MobileFooter: React.FC<MobileFooterProps> = ({ handleAction,backButton,completeButton }) => {
  return (
    <div className="row mt-auto">
      <div className="col-12 d-flex">
        <div className="mt-2 bg-white rounded py-3 mt-auto col">
          <div className="d-flex flex-row-reverse">
            {
           <div className="button-container">
           {backButton && (
             <FormButton
               key={0}
               className="sph-btn me-4"
               handleClick={() => handleAction("back", backButton)}
             >
               Back
             </FormButton>
           )}
           {completeButton && (
             <FormButton
               key={3}
               className="sph-btn sph-shift complete-button"
               handleClick={() => handleAction("complete", completeButton)}
             >
               {completeButton.button_text}
             </FormButton>
           )}
         </div>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileFooter;
